import { apiClient as api } from "./httpClient";

// Mapa de salas (RN-549): um dia, salas × horários de 30 min. A sala efetiva segue a regra do
// relatório de Ocupação (room_id do agendamento ou sala padrão do profissional na data).

export interface RoomMapRoom {
  id: string;
  name: string;
  capacity: number | null;
  /** sala alugada a terceiro neste dia da semana */
  rentedToday: boolean;
}

export interface RoomMapItem {
  scheduleId: string;
  roomId: string | null;
  roomFromAssignment: boolean;
  /** ISO no relógio da entidade */
  start: string;
  end: string;
  patientId: string | null;
  patientName: string | null;
  professionalId: string | null;
  professionalName: string | null;
  serviceName: string | null;
  teamId: string | null;
  confirmation: string | null;
  presence: string | null;
}

export interface RoomMapSlot { time: string; startMinute: number; }
export interface RoomMapOption { id: string; name: string; }

export interface RoomMap {
  date: string;
  weekday: string;
  slotMinutes: number;
  openStartMinute: number;
  openEndMinute: number;
  slots: RoomMapSlot[];
  rooms: RoomMapRoom[];
  items: RoomMapItem[];
  teams: RoomMapOption[];
  /** "roomId|startMinute" dos slots com mais de uma sessão na mesma sala */
  overbooked: string[];
}

export const roomMapService = {
  get: async (date: string, teamId?: string): Promise<RoomMap> => {
    const q = new URLSearchParams({ date });
    if (teamId) q.set("teamId", teamId);
    const response = await api.get(`/room-map?${q.toString()}`, { timeout: 60000 });
    return response.data;
  },
};
